// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wh-8";
export var editMode = "_wh-3";
export var headerRow = "_wh-a";
export var headerTitle = "_wh-b";
export var product = "_wh-1";
export var productDetails = "_wh-5";
export var productDivider = "_wh-7";
export var productImage = "_wh-2";
export var productInfo = "_wh-4";
export var productTitle = "_wh-6";
export var strikethrough = "_wh-9";
export var upsellProductsCard = "_wh-0";